module.exports = __webpack_public_path__ + "img/Susana-Prieto-Heredia.bf45f60e.png";